export default function uniqueObjectsByKey(arr, key) {
  return arr.filter((
    obj,
    index,
    self,
  ) => index === self.findIndex((f) => (
    f[key] === obj[key]
  )));
}
